import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IResponseBase } from './interfaces/CmydIResponseBase';
import { IResponsePagedBase } from './interfaces/CmydIResponsePagedBase';

@Injectable({
  providedIn: 'root'
})
export abstract class CmydBaseServiceService<T, IResponse extends IResponseBase<T>, IResponsePaged extends IResponsePagedBase<T>> {

  abstract route: string;
  abstract pagedRoute: string;
  abstract listRoute: string;

  private baseHttp!: HttpClient;

  public setHttpClient(tempClient: HttpClient) {
    this.baseHttp = tempClient;
  }

  public getItem(id: string): Observable<IResponse> {
    return this.baseHttp!.get<IResponse>(this.route! + "?id=" + id);
  }

  public getItems(params?: HttpParams): Observable<IResponsePaged> {
    return this.baseHttp!.get<IResponsePaged>(this.pagedRoute, { params });
  }

  public getAllItems(): Observable<IResponsePaged> {
    return this.baseHttp!.get<IResponsePaged>(this.listRoute!);
  }

  public createItem(item: T): Observable<any> {
    return this.baseHttp!.post<any>(this.route!, item);
  }

  public updateItem(item: T, id?: string) {
    return this.baseHttp!.put<any>(this.route + (id ? "/" + id : ""), item);
  }

  public deleteItem(id: string) {
    return this.baseHttp!.delete<any>(this.route + "/" + id);
  }

}

